import { React, useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import styled from 'styled-components';

import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as DownArrowSvg } from '../../../image/DownArrow.svg';

export default function NewCountInput(props) {
  const { disabled, value, setValue } = props;
  const { t, isEng } = useLanguage();
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const InputRef = useRef();

  function onChangeInput(e) {
    const curValue = e.target.value
		const newValue = curValue.replace(/[^0-9]/g, '')

    if (newValue < 9999999)
		  setValue(newValue);
  }

  function onFocusInput() {
    InputRef.current.style.border = `1px solid ${theme.primary}`;
  }

  function onBlurInput() {
    InputRef.current.style.border = `1px solid ${theme.line}`;
  }

  function upClick() {
    if (disabled) return;

    if (value < 9999999) setValue(parseInt(value) + 1)
    else setValue(0);
  }

  function downClick() {
    if (disabled) return;

    if (value > 0) setValue(parseInt(value) - 1)
  }

  return (
    <TopLevelWrapper>
      <LayerWrapper>
        <Title $isEng={isEng}>{t('memberDetail.extensionModal.countAdd')}</Title>
        <Input 
          ref={InputRef}
          placeholder='0'
          value={value || ''}
          disabled={disabled}
          onFocus={onFocusInput}
          onChange={onChangeInput}
          onBlur={onBlurInput}/>
      </LayerWrapper>
      <LayerWrapper>
        <Text>{t('memberDetail.extensionModal.countSuffix')}</Text>
      </LayerWrapper>
      <LayerWrapper>
        <ButtonWrapper>
          <Button onClick={upClick}><StyledArrow isUp /></Button>
          <Button onClick={downClick}><StyledArrow /></Button>
        </ButtonWrapper>
      </LayerWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const Title = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: ${props => props.$isEng ? 12 : 14}px;

  color: ${props => props.theme.subText};

  margin: 0 16px 0 0;
`;

const Input = styled.input`
  width: 61px;
  height: 28px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  margin: 0 8px 0 0;
  padding: 0 0 0 8px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  outline: none;

  color: ${props => props.theme.text};
  background-color: ${props => props.disabled ? props.theme.buttonFill : props.theme.subBackground};

  transition: all 0.3s ease-in-out;

  &::placeholder {
    color: ${props => props.theme.subText};
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 8px 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  gap: 4px;
  // margin-top: 24px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  align-items: center;

  width: 28px;
  height: 28px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  background-color: ${props => props.theme.buttonFill};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const StyledArrow = styled(DownArrowSvg)`
  width: 15px;
  height: auto;
  flex-shrink: 0;

  color: ${props => props.theme.subText};
  transform: ${props => props.isUp ? 'rotate(180deg)' : 'rotate(0deg)'};
`;